import { BadgeCheck, Bell, Settings } from 'lucide-react'
import { SettingsSidebar, type SettingsSidebarItem } from '@/components/shared/settings-sidebar'

export type UserAccountSection = 'account' | 'notifications' | 'settings'

const navItems: SettingsSidebarItem<UserAccountSection>[] = [
  {
    title: 'Account',
    value: 'account',
    icon: BadgeCheck,
  },
  {
    title: 'Notifications',
    value: 'notifications',
    icon: Bell,
  },
  {
    title: 'Settings',
    value: 'settings',
    icon: Settings,
  },
]

interface UserAccountSidebarProps {
  currentSection: UserAccountSection
  onSectionChange: (section: UserAccountSection) => void
}

export function UserAccountSidebar({ currentSection, onSectionChange }: UserAccountSidebarProps) {
  return (
    <SettingsSidebar
      mode="button"
      items={navItems}
      currentSection={currentSection}
      onSectionChange={onSectionChange}
      className="flex-1"
    />
  )
}
